import React, { useEffect, useState } from "react";

import {
  Container,
  AppBar,
  TableCell,
  TableHead,
  TableBody,
  Table,
  TableRow,
  Link,
  Typography,
  Grid,
  Icon,
} from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import { Alert } from "@material-ui/lab";
import { formatMoney, PaymentContainer, Translator } from "@itarget/shared";
import "./style.scss";

const PaymentView = ({
  authRedux,
  settingCommerce,
  onInvalidCardPayment,
  toast,
  centerCostId,
  paymentType,
  payment,
  subscription,
  total,
  person,
  addressCorresp,
  id,
  reprintBillet,
  subscriptionPaid,
  goTo,
}) => {
  return (
    <Container maxWidth="lg" className="payment-view-container">
      <Logo logoUrl={settingCommerce?.url_image_login} />
      <UserInfo userName={person?.data?.nome} />
      <Activity subscription={subscription} subscriptionPaid={subscriptionPaid} total={total} />
      {/* {subscription && subscription[0]?.tempo_desconto_app_entity > 0 && <Countdown discountEndTime={new Date().getTime() + subscription[0]?.tempo_desconto_app_entity * 60 * 1000} />} */}
      <Payment
        authRedux={authRedux}
        subscription={subscription}
        person={person}
        addressCorresp={addressCorresp}
        payment={payment}
        paymentType={paymentType}
        toast={toast}
        total={total}
        id={id}
        onInvalidCardPayment={onInvalidCardPayment}
        centerCostId={centerCostId}
        goTo={goTo}
        reprintBillet={reprintBillet}
      />
      <AlertCorrespondence subscription={subscription} addressCorresp={addressCorresp} />
    </Container>
  );
};

const Logo = ({ logoUrl, altText = 'logo' }) => {
  return (
    <Grid container justify="center" className="logo-container">
      <img className="img-logo" src={logoUrl} alt={altText} />
    </Grid>
  );
};

const UserInfo = ({ userName }) => {
  return (
    <Grid container className="user-info">
      <Alert
        icon={false}
        variant="outlined"
        color="info"
        className="user-alert"
        style={{ width: '100%' }}
      >
        <PersonIcon />
        {userName}
      </Alert>
    </Grid>
  );
};

const Countdown = ({ discountEndTime }) => {
  const [timeRemaining, setTimeRemaining] = useState(discountEndTime - new Date().getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = discountEndTime - new Date().getTime();
      setTimeRemaining(remaining);

      if (remaining <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [discountEndTime]);

  const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

  return (
    <Grid container className="activity-table" style={{ paddingTop: '20px', paddingBottom: '20px', width: '100%' }}>
      <Alert variant="outlined" color="info" style={{ width: '100%' }}>
        {timeRemaining > 0 ? (
          <Typography>
            Tempo restante para pagar com desconto: {minutes} minutos e {seconds} segundos
          </Typography>
        ) : (
          <Typography>O tempo para o pagamento com desconto expirou.</Typography>
        )}
      </Alert>
    </Grid>
  );
};

const Activity = ({ subscription, subscriptionPaid, total }) => {
  return (
    <Grid container className="activity-table">
      {subscription?.length >= 2 ? (
        <Alert variant="outlined" color="warning" className="warning-alert">
          <Translator transRef="translation.Pagamento permitido somente para uma atividade" />
        </Alert>
      ) : (
        <>
          {subscription?.filter((subs) => subs.esta_vencido === "S").length > 0 && (
            <Grid item className="ribbon">
              <Translator transRef="translation.Vencido" />
            </Grid>
          )}

          {subscription?.length > 0 && (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Translator transRef="translation.Atividade" />
                  </TableCell>
                  <TableCell align="right">
                    <Translator transRef="translation.Valor" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subscription?.map(
                  ({
                    id,
                    agenda_atividade_idioma_descricao,
                    cr_valor,
                    aplicar_desconto_pgto_app,
                    desconto_app,
                    tipo_desconto_app,
                    desconto_app_entity
                  }) => (
                    <React.Fragment key={id}>
                      <TableRow>
                        <TableCell>{agenda_atividade_idioma_descricao}</TableCell>
                        <TableCell align="right">
                          R$ {formatMoney.toReal(cr_valor)}
                        </TableCell>
                      </TableRow>
                      {desconto_app_entity && aplicar_desconto_pgto_app === 'S' && (
                        <TableRow className="discount-row">
                          <TableCell className="discount-description">
                            (Desconto Pagamento aplicativo){" "}
                            <span className="discount-detail">
                              {agenda_atividade_idioma_descricao}
                            </span>
                          </TableCell>
                          <TableCell align="right" className="discount-value">
                            - R$ {tipo_desconto_app === 'V' ? formatMoney.toReal(desconto_app) : formatMoney.toReal((desconto_app * cr_valor) / 100)}
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  )
                )}
                <TableRow key="total">
                  <TableCell>
                    <Translator transRef="translation.Total" />
                  </TableCell>
                  <TableCell align="right">
                    R$ {formatMoney.toReal(total)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          )}

          {subscriptionPaid?.length > 0 && (
            <Table className="receipt-table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Translator transRef="translation.Atividade" />
                  </TableCell>
                  <TableCell>
                    <Translator transRef="translation.Recibo" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subscriptionPaid?.map(
                  ({ id, agenda_atividade_idioma_descricao, link_recibo }) => (
                    <TableRow key={id}>
                      <TableCell>{agenda_atividade_idioma_descricao}</TableCell>
                      <TableCell>
                        <Grid
                          className="receipt-link"
                          onClick={(event) => {
                            window.open(link_recibo);
                            event.stopPropagation();
                          }}
                        >
                          <Typography>
                            <Translator transRef="translation.Comprovante" />
                          </Typography>
                          <Icon className="receipt-icon">play_arrow</Icon>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          )}
        </>
      )}
    </Grid>
  )
}

const Payment = ({ subscription, reprintBillet, paymentType, payment, onInvalidCardPayment, id, toast, total, person, centerCostId, addressCorresp, goTo, authRedux }) => {
  return (
    <>
      {subscription?.length < 2 && (
        <Grid container className="payment-actions">
          <AppBar position="static" color="default">
            {subscription?.filter((subs) => subs.esta_vencido === "S").length < 1 && subscription[0]?.hash_transacao && (
              <Grid className="grid-left-infos">
                <Link
                  target="_blank"
                  onClick={(event) => {
                    event.preventDefault();
                    reprintBillet(subscription[0]);
                  }}
                >
                  <Typography>
                    <Translator transRef="translation.Reimprimir boleto" />
                  </Typography>
                </Link>
              </Grid>
            )}

            {addressCorresp && person?.data?.id && subscription && subscription?.filter((subs) => subs.esta_vencido === "S").length < 1 && (
              <PaymentContainer
                authRedux={authRedux}
                centro_custo_id={centerCostId}
                toast={toast}
                paymentType={paymentType}
                subscriptionState={subscription}
                paymentRedux={payment}
                total={total}
                user={person}
                onInvalidCardPayment={onInvalidCardPayment}
                showFormData={false}
                routerFinishBank={`payment/${id}`}
                routeFinishPayment={`payment/${id}`}
                goFinish={() => {
                  goTo(`payment/${id}`);
                }}
              />
            )}
          </AppBar>
        </Grid>
      )}
    </>
  )
}

const AlertCorrespondence = ({ subscription, addressCorresp }) => {
  return (<>
    {addressCorresp === null && subscription?.length < 2 && (
      <Grid container className="address-alert">
        <Alert color="warning">
          <Translator transRef="translation.Você não tem endereço de correspondencia complete na area do associado pelo site e depois retornar no link para pagamento." />
        </Alert>
      </Grid>
    )}
  </>)
}

export default PaymentView;
